import common from "../../utill/Common";

class CompanyService {
  fetchByDomainName = async (domain_name) => {
    const url = common.baseUrl + "user/company/fetch_by_domain_name";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "x-access-token": token,
      },
      body: JSON.stringify({ domain_name: domain_name }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  getCompanyData = async () => {
    const company = JSON.parse(localStorage.getItem("company"));

    if (!company) {
      return;
    }

    return company;
  };

  fetchCompanyDetails = async (token) => {
    const url = common.baseUrl + "user/company/fetch_company_details";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateCompanyDetails = async (
    token,
    company_name,
    legal_name,
    primary_domain,
    android_app,
    phone,
    email,
    address,
    pan_number,
    gstin
  ) => {
    const url = common.baseUrl + "user/company/update_company_details";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        company_name,
        legal_name,
        primary_domain,
        android_app,
        phone,
        email,
        address,
        pan_number,
        gstin,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateBrandingSettings = async (token, title_text, footer_text) => {
    const url = common.baseUrl + "user/company/update_branding_settings";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        title_text,
        footer_text,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateEmailSettings = async (
    token,
    email,
    encryption,
    smtp_host,
    smtp_port,
    smtp_username,
    smtp_password
  ) => {
    const url = common.baseUrl + "user/company/update_email_settings";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        email,
        encryption,
        smtp_host,
        smtp_port,
        smtp_username,
        smtp_password,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  sendTestMail = async (token, email) => {
    const url = common.baseUrl + "user/company/send_test_mail";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        email,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  uploadLogo = async (token, type, logo) => {
    let endpoint;

    switch (type) {
      case "logo":
        endpoint = "upload_logo";
        break;

      case "white_logo":
        endpoint = "upload_white_logo";
        break;

      case "favicon":
        endpoint = "upload_favicon";
        break;

      default:
        break;
    }

    const url = common.baseUrl + "user/company/" + endpoint;

    const dataArray = new FormData();
    dataArray.append(type, logo);

    const options = {
      method: "POST",
      headers: {
        // "Content-Type": "multipart/form-data",
        "x-access-token": token,
      },
      body: dataArray,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  getLogo = async (token, type) => {
    const url = common.baseUrl + "user/company/get_logo";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        type,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CompanyService();
